var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.401C13.7183 6.401 14.4072 6.6586 14.9151 7.11712C15.423 7.57565 15.7083 8.19755 15.7083 8.846C15.7083 9.16708 15.6383 9.48502 15.5022 9.78166C15.3661 10.0783 15.1666 10.3478 14.9151 10.5749C14.6636 10.8019 14.365 10.982 14.0364 11.1049C13.7078 11.2278 13.3557 11.291 13 11.291C12.2817 11.291 11.5928 11.0334 11.0849 10.5749C10.577 10.1163 10.2917 9.49445 10.2917 8.846C10.2917 8.19755 10.577 7.57565 11.0849 7.11712C11.5928 6.6586 12.2817 6.401 13 6.401ZM13 2C15.0112 2 16.9401 2.72127 18.3622 4.00515C19.7844 5.28902 20.5833 7.03033 20.5833 8.846C20.5833 13.9805 13 21.56 13 21.56C13 21.56 5.41666 13.9805 5.41666 8.846C5.41666 7.03033 6.21561 5.28902 7.63776 4.00515C9.05991 2.72127 10.9888 2 13 2ZM13 3.956C11.5634 3.956 10.1857 4.47119 9.16983 5.38825C8.15401 6.3053 7.58332 7.54909 7.58332 8.846C7.58332 9.824 7.58332 11.78 13 18.3424C18.4167 11.78 18.4167 9.824 18.4167 8.846C18.4167 7.54909 17.846 6.3053 16.8302 5.38825C15.8143 4.47119 14.4366 3.956 13 3.956Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.ab3541ec15e3ac31d4519debb44adad6.svg";
export { ForwardRef as ReactComponent };